import { useEffect } from "react";
import { useUploadPreprocessor } from "../UploadPreprocessorContext";
import UploadIssueFileCard from "./UploadIssueFileCard";

const UploadIssuesFileList = () => {
  const {
    uploadIssues,
    missingFilesDetected,
    selectedUploadIssueType,
    setSelectedUploadIssueType,
  } = useUploadPreprocessor();

  const filteredUploadIssues = uploadIssues.filter(
    (x) => x.type === selectedUploadIssueType,
  );

  useEffect(() => {
    if (
      !missingFilesDetected &&
      !filteredUploadIssues.length &&
      uploadIssues.length
    ) {
      setSelectedUploadIssueType(uploadIssues[0].type);
    }
  }, [uploadIssues, filteredUploadIssues]);

  return (
    !missingFilesDetected && (
      <div className="space-y-3">
        {filteredUploadIssues.map((uploadIssue) => (
          <UploadIssueFileCard
            key={uploadIssue.file.name}
            uploadIssue={uploadIssue}
          />
        ))}
      </div>
    )
  );
};

export default UploadIssuesFileList;
